<template>
  <layout-component>
    <div class="banner banner-articles">
      <div class="container">
        <div class="row d-md-flex justify-content-md-center">
          <div class="col-md-12">
              <div class="bullets">
            <h1 class="left-bullet" v-html="$t('w.articles.title-banner')"></h1>
              <h2 class="right-bullet" v-html="$t('w.articles.subtitle-banner')"></h2>
              </div>
          </div>
          </div>

          <nav>
              <ul class="categories nav-list">
                  <li class="nav-item">
                    <router-link class="nav-link" to="/blog" :class="{'active': $route.path == '/blog'}">{{ $t('w.articles.all') }}</router-link>
                  </li>
                  <li v-for="(category, index) in categories" class="nav-item" :key="index">
                      <router-link class="nav-link" :to="'/blog/category/'+category.id" active-class="active">{{category.name}}</router-link>
                  </li>
              </ul>

          </nav>

      </div>
    </div>
    <div class="container">
        <div class="">
          <template v-for="post in blogposts" >
            <div class="card-blog article">
              <router-link :to="'/blog/post/'+post.slug">
                <div class="img-wrapper">
                  <div class="noise">
                      <div class="ratio">
                    <img class="img-fluid"  v-if="post.image" :src="'/storage/'+post.image" loading="lazy" :alt="$i18n.locale == 'fr' ? post.title : post.title_en" />
                      </div>
                  </div>
                </div>
                <div class="text-wrapper">
                  <div class="date">{{ post.date | formatDateBlog }}</div>

                    <div class="category"  v-if="post.category">{{ $i18n.locale == 'fr'  ? post.category.name : post.category.name_en }}</div>
  <div class=" bottom-cut"></div>
                  <h3>{{ $i18n.locale == 'fr' ? post.title : post.title_en }}</h3>
                </div>
              </router-link>
            </div>
          </template>
        </div>
    </div>
    <div class="container mb-4" v-if="datas.last_page && datas.last_page > 1">
      <div class="row d-flex justify-content-center">
        <Pagination :data="datas"></Pagination>
      </div>
    </div>
  </layout-component>
</template>

<script>
    export default {
      data() {
        return {
          blogposts: null,
          categories: null,
          datas: {},
          page: 1
        }
      },

      mounted(){
        if (this.$route.query.page) {
          this.page = this.$route.query.page
        }
        this.fetchData();
      },

      methods: {
        fetchData() {
          Vue.axios.get('/blogcategories').then( ({data}) => {
              this.categories = data
          }).catch(() => {});

          if(this.$route.params.id) {
              Vue.axios.get(`/articles/${this.$route.params.id}?page=${this.page}`).then(({data}) => {
                  this.datas = data;
                  this.blogposts = data.data
              }).catch(() => {})
          }else{
              Vue.axios.get(`/articles?page=${this.page}`).then( ({data}) => {
                this.datas = data;
                this.blogposts = data.data
              }).catch(() => {});
          }
        },
      }
    }
</script>
